import { Link } from "react-router-dom";
import { ProductPack } from "@/components/ProductPack";
import { useBasket } from "@/context/BasketContext";
import { formatPrice } from "@/lib/api";

export const ProductCard = ({ product, dark = false }) => {
    const { addItem } = useBasket();
    const isPack = product.category === "cut";

    return (
        <div
            className={`product-card group relative flex flex-col rounded-xl p-6 sm:p-8 ${
                dark ? "bg-white/[0.03] border border-white/10" : "bg-white/50 border border-black/[0.07]"
            }`}
            data-testid={`product-card-${product.slug}`}
        >
            {product.limited_edition && (
                <span className="absolute top-4 right-4 font-mono-meta text-[9px] tracking-[0.2em] px-2.5 py-1 rounded-sm bg-[#C9B37A]/15 text-[#8C6A3D] border border-[#C9B37A]/40">
                    LIMITED
                </span>
            )}
            <Link to={`/product/${product.slug}`} className="block flex-1" data-testid={`product-link-${product.slug}`}>
                {isPack ? (
                    <div className="h-[280px] sm:h-[300px] flex items-center justify-center">
                        <ProductPack product={product} size="md" />
                    </div>
                ) : (
                    <div className="rounded-lg overflow-hidden h-[280px] sm:h-[300px]">
                        <img
                            src={product.images[0]}
                            alt={product.name}
                            loading="lazy"
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                        />
                    </div>
                )}
                <div className="mt-5 text-center">
                    <h3
                        className={`font-serif-display text-xl sm:text-2xl font-medium ${
                            dark ? "text-[#F6F1E7]" : "text-[#0B0B0C]"
                        }`}
                    >
                        {product.name}
                    </h3>
                    <p className={`mt-1.5 text-xs leading-relaxed line-clamp-2 min-h-[2rem] ${dark ? "text-[#F6F1E7]/55" : "text-black/55"}`}>
                        {product.subtitle}
                    </p>
                    <div className="mt-3 flex items-center justify-center gap-3">
                        <span className={`text-sm font-semibold ${dark ? "text-[#C9B37A]" : "text-[#0F2A1F]"}`}>
                            {formatPrice(product.price)}
                        </span>
                        {product.category !== "accessory" && (
                            <span className={`font-mono-meta text-[10px] tracking-wide ${dark ? "text-white/40" : "text-black/40"}`}>
                                {product.protein_g}g protein · {product.weight_g}g
                            </span>
                        )}
                    </div>
                </div>
            </Link>
            <button
                onClick={() => addItem(product)}
                className={`btn-luxe mt-5 w-full ${dark ? "btn-outline-light" : "btn-outline-dark"} group-hover:!bg-[#0F2A1F] group-hover:!text-[#F6F1E7] group-hover:!border-[#0F2A1F]`}
                data-testid={`add-to-basket-${product.slug}`}
            >
                Add to Basket
            </button>
        </div>
    );
};
